import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {
    getNotificationRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getNotificationSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload.data || null;
    },
    getNotificationFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getNotificationRequest,
  getNotificationSuccess,
  getNotificationFailure,
} = notificationSlice.actions;

export default notificationSlice.reducer;
